import { render, staticRenderFns } from "./RedeemResultList.vue?vue&type=template&id=4ade5523&scoped=true&"
import script from "./RedeemResultList.vue?vue&type=script&lang=js&"
export * from "./RedeemResultList.vue?vue&type=script&lang=js&"
import style0 from "./RedeemResultList.vue?vue&type=style&index=0&id=4ade5523&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4ade5523",
  null
  
)

export default component.exports